import { types } from "../action-types";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const VmsFacilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_FACILITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_FACILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload?.facilities, 
      };

    case types.FETCH_FACILITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default VmsFacilityReducer;
